import React, { useState, useEffect, useRef } from 'react'
import { Card } from 'antd'
import { getMerchantName, getDetailReport, downloadDetailReport } from '../../services/nfcScan/nfcScan'
import { getANTTemplateList } from '../../services/configuration/config'
import { paginationInit, formatMessage, downLoadFileBlob, formatStartTime, formatEndTime } from '../../utils/common'
import dayjs from 'dayjs'
import AntdTable from '../../components/table/AntdTable'
import SearchBar from '../../components/searchbar/SearchBar'
import ActionBar from '@/components/table/ActionBar'
import { useSelector } from 'react-redux'

const dateFormat = 'YYYY-MM-DD'
const startMonth = dayjs()
  .subtract(1, 'months')
  .add(1, 'day')
const endMonth = dayjs()

const spans = { xl: 8, xxl: 8 }

const NFCScanDetailReport = () => {
  const commonStore = useSelector(state => state.commonStore)
  const language = useSelector(state => state.commonStore.language)
  const formRef = useRef(null)
  const mounting = useRef(false)

  const columnList = [
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.scanDate'),
      dataIndex: 'scanDate'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.productCode'),
      dataIndex: 'productCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.productName'),
      dataIndex: 'productName'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.templateName'),
      dataIndex: 'templateName'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.merchantName'),
      dataIndex: 'merchantName'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.traceCode'),
      dataIndex: 'traceCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.uid'),
      dataIndex: 'uid'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noOfScans'),
      dataIndex: 'noOfScans'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noScanUser'),
      dataIndex: 'noScanUser'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noOfClicks'),
      dataIndex: 'noOfClicks'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.click1Name'),
      dataIndex: 'click1Link',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noOfClick1'),
      dataIndex: 'noOfClick1',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.click2Name'),
      dataIndex: 'click2Link',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noOfClick2'),
      dataIndex: 'noOfClick2',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.click3Name'),
      dataIndex: 'click3Link',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noOfClick3'),
      dataIndex: 'noOfClick3',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.click4Name'),
      dataIndex: 'click4Link',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noOfClick4'),
      dataIndex: 'noOfClick4',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.click5Name'),
      dataIndex: 'click5Link',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noOfClick5'),
      dataIndex: 'noOfClick5',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.click6Name'),
      dataIndex: 'click6Link',
      type: 'detail'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcScanLocale.noOfClick6'),
      dataIndex: 'noOfClick6',
      type: 'detail'
    }
  ]

  const searchListInit = [
    {
      type: 'timeRange',
      label: 'languageObj.nfcScanLocale.scanDate',
      key: 'scanDate',
      disabledDate: current => {
        return (
          (current && current > dayjs().endOf('day')) ||
          current <
            dayjs()
              .subtract(6, 'months')
              .startOf('day')
        )
      },
      format: dateFormat,
      initialValues: [startMonth, endMonth],
      spans,
      isdefaultfilter: 'true'
    },
    {
      type: 'textarea',
      label: 'languageObj.nfcScanLocale.productCode',
      key: 'productCodes',
      initialValues: undefined,
      spans,
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.nfcScanLocale.productName',
      key: 'productName',
      initialValues: '',
      spans,
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.nfcScanLocale.template',
      key: 'templates',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans,
      isdefaultfilter: 'true'
    },
    {
      type: 'textarea',
      label: 'languageObj.nfcScanLocale.uid',
      key: 'uids',
      initialValues: undefined,
      spans,
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.nfcScanLocale.merchantName',
      key: 'merchantNames',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans,
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.nfcScanLocale.traceCode',
      key: 'traceCode',
      initialValues: '',
      spans
    },
    {
      type: 'input',
      label: 'languageObj.nfcScanLocale.click1Name',
      key: 'click1Name',
      initialValues: '',
      spans
    },
    {
      type: 'input',
      label: 'languageObj.nfcScanLocale.click2Name',
      key: 'click2Name',
      initialValues: '',
      spans
    },
    {
      type: 'input',
      label: 'languageObj.nfcScanLocale.click3Name',
      key: 'click3Name',
      initialValues: '',
      spans
    },
    {
      type: 'input',
      label: 'languageObj.nfcScanLocale.click4Name',
      key: 'click4Name',
      initialValues: '',
      spans
    },
    {
      type: 'input',
      label: 'languageObj.nfcScanLocale.click5Name',
      key: 'click5Name',
      initialValues: '',
      spans
    },
    {
      type: 'input',
      label: 'languageObj.nfcScanLocale.click6Name',
      key: 'click6Name',
      initialValues: '',
      spans
    }
  ]

  const [tableList, setTableList] = useState([])
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)

  useEffect(() => {
    initSearchList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (mounting.current) searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const initSearchList = () => {
    Promise.all([getANTTemplateList({ pageNo: 1, size: 100 }), getMerchantName()]).then(res => {
      try {
        searchListInit.forEach(searchItem => {
          if (['templates', 'merchantNames'].includes(searchItem.key)) {
            let options = []
            switch (searchItem.key) {
              case 'templates':
                const templateList = res[0].resultData.records
                options = templateList.map(item => ({ value: item.template, label: item.template }))
                break
              case 'merchantNames':
                const merchNameList = res[1].resultData
                options = merchNameList.map(item => ({ value: item.merchantName, label: item.merchantName }))
                break
              default:
                break
            }
            searchItem.selectList = options
          }
        })
        setSearchList([...searchListInit])
      } catch (error) {}
    })
  }

  const searchDataBtn = () => {
    mounting.current = true
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const searchClearDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const getparams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { scanDate, productCodes, uids } = info
    const params = {
      ...info,
      isChinese: language === 'zh_CN' ? true : false,
      start: formatStartTime(scanDate),
      end: formatEndTime(scanDate),
      productCodes: productCodes ? productCodes.split(',') : [],
      uids: uids ? uids.split(',') : []
    }
    delete params.scanDate
    return params
  }

  const searchDataFun = () => {
    const params = getparams()
    params.size = pagination.pageSize
    params.pageNo = pagination.currentPage
    getDetailReport(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const downLoadFun = () => {
    const params = getparams()
    downloadDetailReport(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container">
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end', marginTop: 15 }} />
          {/* <div className="opt_btn mt15 mb15" style={{ display: 'flex', alignItems: 'center' }}>
            <Button type="primary" onClick={downLoadFun} style={{ marginLeft: '20px' }}>
              {formatMessage(commonStore, 'languageObj.commonLocale.download')}
            </Button>
          </div> */}
          <AntdTable
            rowKey={record => record.tagUid}
            dataSource={tableList}
            columns={columnList}
            // 独一无二的标识，不能重复
            columnsKey="nfcScanDetailReportColumns"
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
    </div>
  )
}
export default NFCScanDetailReport
